import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ApisService } from "@core/services/apis.service";
import { LoadingService } from "@core/services/loading.service";

export interface Message {
  id: number;
  contactId: number;
  text: string;
  time: string;
  isSent: boolean;
}

@Component({
  selector: "app-chats",
  templateUrl: "./chats.component.html",
  styleUrls: ["./chats.component.scss"],
})
export class ChatsComponent implements OnInit, AfterViewInit {
  // ** Variables **
  public chats: any[] = [];

  page: number = 1;
  public contacts: any = [];

  public messages: any[] = [];
  public isView: boolean = false;

  public activeContact: any = null;
  public newMessage: string = "";
  public searchText: string = "";
  public selectedFile: File | null = null;
  public filePreview: string | null = null;
  @ViewChild("user-chats")
  set userChatsSetter(content: ElementRef) {
    if (content) {
      this.userChats = content;
      this.scrollToBottom();
    }
  }
  userChats!: ElementRef;
  constructor(
    private apiService: ApisService,
    private loading: LoadingService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.isView = this.route.snapshot.data["isView"];
    this.isView ? this.viewChats() : this.getChats();
    console.log(this.isView);
  }

  ngAfterViewInit(): void {
    this.scrollToBottom();
  }

  getChats() {
    this.apiService.getChats(this.page).subscribe((res) => {
      this.chats = res.data;
      console.log(this.chats);
    });
  }

  viewChats() {
    this.apiService.viewChats().subscribe({
      next: (res) => {
        this.chats = res.data;
        console.log(this.filteredContacts);
      },
    });
  }

  getMessages(id: number) {
    this.loading.show();
    this.apiService.getChatMessages(id).subscribe({
      next: (res) => {
        this.messages = res.data;
        this.scrollToBottom();
      },
      error: (err) => {
        console.log(err);
      },
      complete: () => {
        this.loading.hide();
      },
    });
  }

  selectChat(contact: any) {
    this.activeContact = contact;
    this.getMessages(contact.id);
  }

  onFileSelected(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.selectedFile = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        this.filePreview = e.target?.result as string;
      };
      reader.readAsDataURL(this.selectedFile);
    }
  }

  removeFile() {
    this.selectedFile = null;
    this.filePreview = null;
  }

  sendMessage() {
    this.loading.show();
    if (this.newMessage.trim() === "" && !this.selectedFile) return;

    const formData = new FormData();
    formData.append("room_id", this.activeContact.id);
    formData.append("message", this.newMessage);
    formData.append("type", this.selectedFile ? "file" : "text");
    if (this.selectedFile) {
      formData.append("file", this.selectedFile);
    }

    this.apiService[this.selectedFile ? "uploadFile" : "sendMessage"](
      this.activeContact?.id,
      formData,
    ).subscribe({
      next: (res) => {
        this.messages.push({
          id: this.messages.length + 1,
          contactId: this.activeContact.id,
          message: this.newMessage,
          file_path: this.filePreview,
          created_at: new Date().toLocaleTimeString(),
        });
        console.log(this.messages);
        this.newMessage = "";
        this.selectedFile = null;
        this.filePreview = null;
        this.scrollToBottom();
      },
      error: (err) => {
        console.log(err);
      },
      complete: () => {
        this.loading.hide();
      },
    });
  }

  get filteredContacts() {
    return this.chats.filter((c) =>
      c.users?.name?.toLowerCase().includes(this.searchText.toLowerCase()),
    );
  }

  imageError(event: any) {
    event.target.src = "assets/images/icons/user.svg";
    event.target.style.objectFit = "contain";
    event.target.style.backgroundColor = "#fff";
    event.target.style.padding = "5px";
    event.target.style.borderRadius = "50%";
    event.target.style.border = "1px solid #7367f0";
  }

  scrollToBottom() {
    setTimeout(() => {
      if (this.userChats) {
        this.userChats.nativeElement.scrollTop =
          this.userChats.nativeElement.scrollHeight;
      }
    }, 0);
  }
}
